// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  width: 100%;
}

.link-button {
    display: block;
    width: 100%;
    padding: 10px 20px;
    text-align: center;
    font-size: 1.2rem;
    font-family: "Open Sans", sans-serif;
    color: white;
    text-decoration: none;
    border: 1px solid white;
    background: none;
    box-sizing: border-box;
    cursor: pointer;
}

.link-button:link, .link-button:visited, .link-button:active {
    color: white;
    text-decoration: none;
}

.link-button:hover {
    color: #8cc63e;
    background: white;
    text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/LinkButton/LinkButton.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;IACpC,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB","sourcesContent":[":host {\n  display: inline-block;\n  width: 100%;\n}\n\n.link-button {\n    display: block;\n    width: 100%;\n    padding: 10px 20px;\n    text-align: center;\n    font-size: 1.2rem;\n    font-family: \"Open Sans\", sans-serif;\n    color: white;\n    text-decoration: none;\n    border: 1px solid white;\n    background: none;\n    box-sizing: border-box;\n    cursor: pointer;\n}\n\n.link-button:link, .link-button:visited, .link-button:active {\n    color: white;\n    text-decoration: none;\n}\n\n.link-button:hover {\n    color: #8cc63e;\n    background: white;\n    text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
